import { Params } from '@angular/router';
import { LinkTarget } from '@stylehaven/components';

export interface NavigationOptions {
    readonly editMode: boolean;
    readonly tab?: string;
    readonly state?: object;
    readonly queryParams?: Params;
    readonly target?: LinkTarget;
    readonly version?: number;
    readonly hideToasts?: boolean;
}

export const defaultNavigationOptions: NavigationOptions = {
    editMode: false,
    hideToasts: false
};
